import { advancedShippingNoticeGridProperties } from '../grid-properties';
import { actionsColumn } from './actions';
import { dateCreatedColumn } from './date-created';
import { dateLastUpdatedColumn } from './date-last-updated';
import { dateSubmittedColumn } from './date-submitted';
import { nameColumn } from './name';
import { statusColumn } from './status';

/**
 * @typedef {import('./types').GridColumn} GridColumn
 */
export default {
  [advancedShippingNoticeGridProperties.name]: nameColumn,
  [advancedShippingNoticeGridProperties.status]: statusColumn,
  [advancedShippingNoticeGridProperties.dateCreated]: dateCreatedColumn,
  [advancedShippingNoticeGridProperties.dateLastUpdated]: dateLastUpdatedColumn,
  [advancedShippingNoticeGridProperties.dateSubmitted]: dateSubmittedColumn,
  [advancedShippingNoticeGridProperties.actions]: actionsColumn,
};
